/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * grimoire/v1/import_export.proto
 * OpenAPI spec version: version not set
 */

/**
 * Activation state of a published automation.
Controls whether the automation can execute published runs.

 - AUTOMATION_ACTIVATION_STATE_UNSPECIFIED: Unspecified state. Used when automation has no published version.
Activation state is only meaningful after publishing.
 - AUTOMATION_ACTIVATION_STATE_ACTIVE: Automation is active and can execute published runs.
 - AUTOMATION_ACTIVATION_STATE_DEACTIVATED: Automation is deactivated and cannot execute published runs.
Events will be logged but not executed.
 */
export type V1AutomationActivationState =
  (typeof V1AutomationActivationState)[keyof typeof V1AutomationActivationState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const V1AutomationActivationState = {
  AUTOMATION_ACTIVATION_STATE_UNSPECIFIED:
    'AUTOMATION_ACTIVATION_STATE_UNSPECIFIED',
  AUTOMATION_ACTIVATION_STATE_ACTIVE: 'AUTOMATION_ACTIVATION_STATE_ACTIVE',
  AUTOMATION_ACTIVATION_STATE_DEACTIVATED:
    'AUTOMATION_ACTIVATION_STATE_DEACTIVATED',
} as const;
